module.exports = __webpack_public_path__ + "static/media/healthcare2.33c3a826.png";